import React from 'react';
import { Navigate } from 'react-router-dom';
import useFeatures from 'hooks/useFeatures';

/**
 * Wraps a route element and redirects to /dashboard if the user
 * lacks the required feature. SuperAdmin always passes through.
 * If no features are stored yet (legacy session), also passes through.
 */
const FeatureRoute = ({ featureKey, children, redirectTo = '/dashboard' }) => {
    const { hasFeature, features } = useFeatures();

    // Legacy sessions (no features stored) — let through so existing users aren't locked out
    if (features.length === 0) return children;

    if (!hasFeature(featureKey)) {
        return <Navigate to={redirectTo} replace />;
    }

    return children;
};

export default FeatureRoute;
